import { atom, selector } from "recoil";
import { selectedUserSchemeAtom } from "./user";
import { tenantAccessibleResourcesSelector } from "./tenant";

//GraphQL
import { API, graphqlOperation } from "aws-amplify";
import { liveEventBySchemeBasic, archiveEventBySchemeBasic } from "../graphql/queries-custom";

const parseZoneBreadcrumb = (value) => {
	if (!value) return null;

	try {
		return JSON.parse(value);
	} catch (error) {
		return null;
	}
};

export const selectedEventAtom = atom({
	key: "selectedEventAtom",
	default: null,
});

export const eventTableFiltersAtom = atom({
	key: "eventTableFiltersAtom",
	default: null,
});

export const liveEventsListSelector = selector({
	key: "liveEventsListSelector",
	get: async ({ get }) => {
		const selectedScheme = get(selectedUserSchemeAtom);
		const { id: schemeId } = selectedScheme;
		const {
			data: {
				liveEventByScheme: { items: liveEventData },
			},
		} = await API.graphql(
			graphqlOperation(liveEventBySchemeBasic, {
				schemeId: schemeId,
				sortDirection: "DESC",
			}),
		);

		let filteredLiveEvents = liveEventData;
		if (selectedScheme?.role === "TENANT") {
			const { deviceIds } = await get(tenantAccessibleResourcesSelector);
			filteredLiveEvents = liveEventData.filter((event) => {
				const eventDeviceId = event.deviceId || event.device?.id;
				return deviceIds?.includes(eventDeviceId);
			});
		}

		filteredLiveEvents.map((event) => {
			event.nameFallback = event.device ? event.device.name : `Deleted - ${event.deviceId}`;
			if (event.device) {
				event.device.zoneBreadcrumb = parseZoneBreadcrumb(event.device.zoneBreadcrumb);
			}
			event.createdAt = new Date(event.createdAt);
			event.updatedAt = new Date(event.updatedAt);
		});

		return filteredLiveEvents;
	},
});

export const archiveEventsListSelector = selector({
	key: "archiveEventsListSelector",
	get: async ({ get }) => {
		const selectedScheme = get(selectedUserSchemeAtom);
		const { id: schemeId } = selectedScheme;
		let archiveEventData = [];
		let lastNextToken = null;

		do {
			const {
				data: {
					archiveEventByScheme: { items: archiveEventItems, nextToken },
				},
			} = await API.graphql(
				graphqlOperation(archiveEventBySchemeBasic, {
					schemeId: schemeId,
					sortDirection: "DESC",
					limit: 500,
					nextToken: lastNextToken,
				}),
			);

			lastNextToken = nextToken;
			archiveEventData.push(...archiveEventItems);
		} while (lastNextToken !== null);

		let filteredArchiveEvents = archiveEventData;
		if (selectedScheme?.role === "TENANT") {
			const { deviceIds } = await get(tenantAccessibleResourcesSelector);
			filteredArchiveEvents = archiveEventData.filter((event) => {
				const eventDeviceId = event.deviceId || event.device?.id;
				return deviceIds?.includes(eventDeviceId);
			});
		}

		filteredArchiveEvents.map((event) => {
			event.nameFallback = event.device ? event.device.name : `Deleted - ${event.deviceId}`;
			event.createdAt = new Date(event.createdAt);
			event.updatedAt = new Date(event.updatedAt);
			if (event.device) {
				event.device.zoneBreadcrumb = parseZoneBreadcrumb(event.device.zoneBreadcrumb);
			}
		});

		return filteredArchiveEvents;
	},
});
